

import React, { useState } from 'react'; // Importa React y hooks.
import './profile.css';  // importacion de la hoja de estilos para esta pagina
import Header from '../../components/Header/Header'; // Componente de la cabezera de la pagina.

import SimpleTitle from '../../components/SimpleTitle/SimpleTitle'; // Componente para titulos simples






const Profile = () => {
    
    return (
        <div className='body overflow-hidden right-[auto] left-[auto] flex flex-col bg-white  h-[100dvh]  max-w-[1024px] items-center justify-center w-[100vw] overflow-hidden'>
            <Header  minimal={true} />
            <div className='p-4 flex flex-col flex-1 bg-[#eaf7f5] flex w-full items-center gap-5'>
                <SimpleTitle text='Perfil del usuario' />
                

                
            </div>

        </div>
    );
};

export default Profile;